import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D: () => (/* binding */ PaypalLogo)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/PaypalLogo.tsx


const PaypalLogo = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'paypal-logo-svg', width: 74, height: 18, viewBox: "0 0 74 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M57.2935 7.30886C57.0698 8.85514 55.9458 8.85514 54.86 8.85514H54.2419L54.6751 5.96858C54.7016 5.79368 54.844 5.66541 55.0128 5.66541H55.2963C56.0352 5.66541 56.734 5.66541 57.0945 6.1085C57.3089 6.37345 57.3749 6.76601 57.2935 7.30886ZM56.8203 3.27509H52.7236C52.4432 3.27509 52.2047 3.4895 52.161 3.78036L50.5039 14.8245C50.4719 15.0422 50.6315 15.2391 50.841 15.2391H52.9436C53.1402 15.2391 53.3066 15.0895 53.3374 14.8861L53.8076 11.7547C53.8513 11.4638 54.0898 11.2494 54.3696 11.2494H55.6655C58.3646 11.2494 59.9225 9.87672 60.3298 7.15535C60.5128 5.96536 60.3366 5.02995 59.8066 4.37568C59.2243 3.65599 58.1915 3.27509 56.8203 3.27509Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.4937 7.30886C28.27 8.85514 27.1465 8.85514 26.06 8.85514H25.4419L25.8752 5.96858C25.9017 5.79368 26.0446 5.66541 26.2129 5.66541H26.4964C27.2359 5.66541 27.9341 5.66541 28.2946 6.1085C28.5103 6.37345 28.575 6.76601 28.4937 7.30886ZM28.0209 3.27509H23.9233C23.6429 3.27509 23.4044 3.4895 23.3613 3.78036L21.7041 14.8245C21.6715 15.0422 21.8317 15.2391 22.0412 15.2391H23.9979C24.2777 15.2391 24.5168 15.0254 24.5599 14.7345L25.0073 11.7547C25.0511 11.4638 25.2896 11.2494 25.5694 11.2494H26.866C29.5652 11.2494 31.1225 9.87672 31.5299 7.15535C31.7129 5.96536 31.5367 5.02995 31.0073 4.37568C30.4243 3.65599 29.3915 3.27509 28.0209 3.27509Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.4348 12.0434C37.2401 13.2102 36.3236 13.9934 35.1554 13.9934C34.5701 13.9934 34.1014 13.8029 33.8008 13.4424C33.5014 13.0845 33.3886 12.5752 33.4843 12.0081C33.6657 10.8516 34.5961 10.0428 35.7465 10.0428C36.3198 10.0428 36.786 10.2352 37.0923 10.5996C37.4018 10.9658 37.5242 11.479 37.4348 12.0434ZM40.2485 8.06841H38.2292C38.0561 8.06841 37.9089 8.19541 37.8823 8.3686L37.7935 8.93947L37.6527 8.73293C37.2151 8.09086 36.2403 7.87662 35.2675 7.87662C33.0364 7.87662 31.1318 9.58603 30.7608 11.9837C30.5668 13.18 30.8414 14.3236 31.5117 15.1216C32.1282 15.8547 33.0078 16.1594 34.0549 16.1594C35.8528 16.1594 36.8498 14.9914 36.8498 14.9914L36.7604 15.559C36.7268 15.7746 36.8917 15.9702 37.1073 15.9702H38.9262C39.2141 15.9702 39.4589 15.7579 39.5046 15.4699L40.5954 8.47956C40.6297 8.2634 40.4648 8.06841 40.2485 8.06841Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.2341 12.0434C66.0394 13.2102 65.1236 13.9934 63.9554 13.9934C63.3694 13.9934 62.9007 13.8029 62.5995 13.4424C62.3008 13.0845 62.1879 12.5752 62.283 12.0081C62.4644 10.8516 63.3954 10.0428 64.5459 10.0428C65.1192 10.0428 65.5847 10.2352 65.8916 10.5996C66.2011 10.9658 66.3229 11.479 66.2341 12.0434ZM69.0484 8.06841H67.0291C66.8554 8.06841 66.7089 8.19541 66.6822 8.3686L66.5934 8.93947L66.452 8.73293C66.015 8.09086 65.0403 7.87662 64.0674 7.87662C61.8369 7.87662 59.9312 9.58603 59.5602 11.9837C59.3674 13.18 59.6413 14.3236 60.3117 15.1216C60.9281 15.8547 61.8071 16.1594 62.8548 16.1594C64.6528 16.1594 65.6497 14.9914 65.6497 14.9914L65.5603 15.559C65.5261 15.7746 65.691 15.9702 65.9072 15.9702H67.7255C68.0134 15.9702 68.2588 15.7579 68.3039 15.4699L69.3953 8.47956C69.4296 8.2634 69.2647 8.06841 69.0484 8.06841Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.1751 7.87662H48.3037C48.1248 7.87662 47.9575 7.96916 47.8569 8.1232L45.2755 12.0814L44.1814 8.27785C44.1129 8.03979 43.9024 7.87662 43.6638 7.87662H41.824C41.6017 7.87662 41.4456 8.10433 41.5175 8.32291L43.5778 14.6203L41.6397 17.4673C41.4883 17.6907 41.6409 18 41.9041 18H43.7737C43.9509 18 44.1176 17.9099 44.2182 17.7577L50.4418 8.40632C50.5904 8.18287 50.4365 7.87662 50.1751 7.87662Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M71.182 3.57825L69.4045 14.8239C69.3699 15.0422 69.5393 15.2391 69.7614 15.2391H71.5487C71.8451 15.2391 72.0971 15.0247 72.1434 14.7339L73.8955 3.68967C73.93 3.47201 73.7607 3.27509 73.5392 3.27509H71.5383C71.3611 3.27509 71.2094 3.40335 71.182 3.57825Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask0_2179_1863", style: {
                        maskType: 'alpha',
                    }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 18 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.100109 0H15.3157V17.9995H0.100109V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask0_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8118 4.57274C14.0309 3.17264 13.81 2.21981 13.0548 1.35656C12.2231 0.406796 10.7206 -0.000595093 8.79831 -0.000595093H3.21746C2.82456 -0.000595093 2.4904 0.285929 2.4292 0.675527L0.105431 15.4471C0.0595306 15.7386 0.284135 16.0024 0.578509 16.0024H4.02347L3.78601 17.5142C3.74562 17.7688 3.94207 17.9995 4.19973 17.9995H7.10368C7.44701 17.9995 7.74016 17.7491 7.7934 17.4086L7.82217 17.2608L8.36869 13.7832L8.40418 13.5912C8.45804 13.2507 8.75058 12.9997 9.09391 12.9997H9.52843C12.3418 12.9997 14.5444 11.8542 15.1882 8.54051C15.4569 7.15575 15.318 5.99984 14.6068 5.18751C14.3914 4.94148 14.124 4.7384 13.8118 4.57274Z", fill: "#009DDC" }) })), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask1_2179_1863", style: {
                        maskType: 'alpha',
                    }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 14, height: 17 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.100082 0H13.3279V16.0024H0.100082V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask1_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2507 4.57274C13.4608 3.17264 13.249 2.21981 12.5246 1.35656C11.727 0.406796 10.286 -0.000595093 8.44235 -0.000595093H3.08987C2.71304 -0.000595093 2.39256 0.285929 2.33387 0.675527L0.105186 15.4471C0.0611645 15.7386 0.276578 16.0024 0.558905 16.0024H3.8629L4.69286 10.5014L4.66703 10.6738C4.72573 10.2848 5.04386 9.99767 5.42068 9.99767H6.99139C10.0753 9.99767 12.4906 8.68837 13.1961 4.90037C13.2167 4.78809 13.2349 4.6795 13.2507 4.57274Z", fill: "#211D6F" }) })), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask2_2179_1863", style: {
                        maskType: 'alpha',
                    }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 14, height: 17 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.206013 0H13.4341V16.0026H0.206013V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask2_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.69064 4.59134C5.72585 4.35758 5.86966 4.16555 6.06335 4.06861C6.15081 4.02443 6.24942 3.99989 6.35214 3.99989H10.5477C11.0449 3.99989 11.508 4.03425 11.9318 4.10542C12.0527 4.12567 12.1707 4.14959 12.2851 4.17598C12.3996 4.20236 12.5105 4.23181 12.6179 4.26494C12.6719 4.28151 12.7247 4.29869 12.777 4.31648C12.9848 4.38888 13.1785 4.47416 13.3569 4.57294C13.567 3.17222 13.3551 2.22001 12.6308 1.35676C11.8332 0.406381 10.3922 -0.000396729 8.54795 -0.000396729H3.19606C2.81923 -0.000396729 2.49875 0.286127 2.44006 0.675112L0.211376 15.4473C0.167354 15.7388 0.382768 16.0026 0.665095 16.0026H3.96909L4.79905 10.501L5.69064 4.59134Z", fill: "#1C3587" }) }))] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'paypal-logo-svg', width: 74, height: 18, viewBox: "0 0 74 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M57.2935 7.30886C57.0698 8.85514 55.9458 8.85514 54.86 8.85514H54.2419L54.6751 5.96858C54.7016 5.79368 54.844 5.66541 55.0128 5.66541H55.2963C56.0352 5.66541 56.734 5.66541 57.0945 6.1085C57.3089 6.37345 57.3749 6.76601 57.2935 7.30886ZM56.8203 3.27509H52.7236C52.4432 3.27509 52.2047 3.4895 52.161 3.78036L50.5039 14.8245C50.4719 15.0422 50.6315 15.2391 50.841 15.2391H52.9436C53.1402 15.2391 53.3066 15.0895 53.3374 14.8861L53.8076 11.7547C53.8513 11.4638 54.0898 11.2494 54.3696 11.2494H55.6655C58.3646 11.2494 59.9225 9.87672 60.3298 7.15535C60.5128 5.96536 60.3366 5.02995 59.8066 4.37568C59.2243 3.65599 58.1915 3.27509 56.8203 3.27509Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.4937 7.30886C28.27 8.85514 27.1465 8.85514 26.06 8.85514H25.4419L25.8752 5.96858C25.9017 5.79368 26.0446 5.66541 26.2129 5.66541H26.4964C27.2359 5.66541 27.9341 5.66541 28.2946 6.1085C28.5103 6.37345 28.575 6.76601 28.4937 7.30886ZM28.0209 3.27509H23.9233C23.6429 3.27509 23.4044 3.4895 23.3613 3.78036L21.7041 14.8245C21.6715 15.0422 21.8317 15.2391 22.0412 15.2391H23.9979C24.2777 15.2391 24.5168 15.0254 24.5599 14.7345L25.0073 11.7547C25.0511 11.4638 25.2896 11.2494 25.5694 11.2494H26.866C29.5652 11.2494 31.1225 9.87672 31.5299 7.15535C31.7129 5.96536 31.5367 5.02995 31.0073 4.37568C30.4243 3.65599 29.3915 3.27509 28.0209 3.27509Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.4348 12.0434C37.2401 13.2102 36.3236 13.9934 35.1554 13.9934C34.5701 13.9934 34.1014 13.8029 33.8008 13.4424C33.5014 13.0845 33.3886 12.5752 33.4843 12.0081C33.6657 10.8516 34.5961 10.0428 35.7465 10.0428C36.3198 10.0428 36.786 10.2352 37.0923 10.5996C37.4018 10.9658 37.5242 11.479 37.4348 12.0434ZM40.2485 8.06841H38.2292C38.0561 8.06841 37.9089 8.19541 37.8823 8.3686L37.7935 8.93947L37.6527 8.73293C37.2151 8.09086 36.2403 7.87662 35.2675 7.87662C33.0364 7.87662 31.1318 9.58603 30.7608 11.9837C30.5668 13.18 30.8414 14.3236 31.5117 15.1216C32.1282 15.8547 33.0078 16.1594 34.0549 16.1594C35.8528 16.1594 36.8498 14.9914 36.8498 14.9914L36.7604 15.559C36.7268 15.7746 36.8917 15.9702 37.1073 15.9702H38.9262C39.2141 15.9702 39.4589 15.7579 39.5046 15.4699L40.5954 8.47956C40.6297 8.2634 40.4648 8.06841 40.2485 8.06841Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.2341 12.0434C66.0394 13.2102 65.1236 13.9934 63.9554 13.9934C63.3694 13.9934 62.9007 13.8029 62.5995 13.4424C62.3008 13.0845 62.1879 12.5752 62.283 12.0081C62.4644 10.8516 63.3954 10.0428 64.5459 10.0428C65.1192 10.0428 65.5847 10.2352 65.8916 10.5996C66.2011 10.9658 66.3229 11.479 66.2341 12.0434ZM69.0484 8.06841H67.0291C66.8554 8.06841 66.7089 8.19541 66.6822 8.3686L66.5934 8.93947L66.452 8.73293C66.015 8.09086 65.0403 7.87662 64.0674 7.87662C61.8369 7.87662 59.9312 9.58603 59.5602 11.9837C59.3674 13.18 59.6413 14.3236 60.3117 15.1216C60.9281 15.8547 61.8071 16.1594 62.8548 16.1594C64.6528 16.1594 65.6497 14.9914 65.6497 14.9914L65.5603 15.559C65.5261 15.7746 65.691 15.9702 65.9072 15.9702H67.7255C68.0134 15.9702 68.2588 15.7579 68.3039 15.4699L69.3953 8.47956C69.4296 8.2634 69.2647 8.06841 69.0484 8.06841Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.1751 7.87662H48.3037C48.1248 7.87662 47.9575 7.96916 47.8569 8.1232L45.2755 12.0814L44.1814 8.27785C44.1129 8.03979 43.9024 7.87662 43.6638 7.87662H41.824C41.6017 7.87662 41.4456 8.10433 41.5175 8.32291L43.5778 14.6203L41.6397 17.4673C41.4883 17.6907 41.6409 18 41.9041 18H43.7737C43.9509 18 44.1176 17.9099 44.2182 17.7577L50.4418 8.40632C50.5904 8.18287 50.4365 7.87662 50.1751 7.87662Z", fill: "#1C3587" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M71.182 3.57825L69.4045 14.8239C69.3699 15.0422 69.5393 15.2391 69.7614 15.2391H71.5487C71.8451 15.2391 72.0971 15.0247 72.1434 14.7339L73.8955 3.68967C73.93 3.47201 73.7607 3.27509 73.5392 3.27509H71.5383C71.3611 3.27509 71.2094 3.40335 71.182 3.57825Z", fill: "#009DDC" }), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask0_2179_1863", style: {
                    maskType: 'alpha',
                }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 16, height: 18 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.100109 0H15.3157V17.9995H0.100109V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask0_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8118 4.57274C14.0309 3.17264 13.81 2.21981 13.0548 1.35656C12.2231 0.406796 10.7206 -0.000595093 8.79831 -0.000595093H3.21746C2.82456 -0.000595093 2.4904 0.285929 2.4292 0.675527L0.105431 15.4471C0.0595306 15.7386 0.284135 16.0024 0.578509 16.0024H4.02347L3.78601 17.5142C3.74562 17.7688 3.94207 17.9995 4.19973 17.9995H7.10368C7.44701 17.9995 7.74016 17.7491 7.7934 17.4086L7.82217 17.2608L8.36869 13.7832L8.40418 13.5912C8.45804 13.2507 8.75058 12.9997 9.09391 12.9997H9.52843C12.3418 12.9997 14.5444 11.8542 15.1882 8.54051C15.4569 7.15575 15.318 5.99984 14.6068 5.18751C14.3914 4.94148 14.124 4.7384 13.8118 4.57274Z", fill: "#009DDC" }) })), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask1_2179_1863", style: {
                    maskType: 'alpha',
                }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 14, height: 17 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.100082 0H13.3279V16.0024H0.100082V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask1_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2507 4.57274C13.4608 3.17264 13.249 2.21981 12.5246 1.35656C11.727 0.406796 10.286 -0.000595093 8.44235 -0.000595093H3.08987C2.71304 -0.000595093 2.39256 0.285929 2.33387 0.675527L0.105186 15.4471C0.0611645 15.7386 0.276578 16.0024 0.558905 16.0024H3.8629L4.69286 10.5014L4.66703 10.6738C4.72573 10.2848 5.04386 9.99767 5.42068 9.99767H6.99139C10.0753 9.99767 12.4906 8.68837 13.1961 4.90037C13.2167 4.78809 13.2349 4.6795 13.2507 4.57274Z", fill: "#211D6F" }) })), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "mask2_2179_1863", style: {
                    maskType: 'alpha',
                }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 14, height: 17 }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.206013 0H13.4341V16.0026H0.206013V0Z", fill: "white" }) })), (0,jsx_runtime.jsx)("g", Object.assign({ mask: "url(#mask2_2179_1863)" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.69064 4.59134C5.72585 4.35758 5.86966 4.16555 6.06335 4.06861C6.15081 4.02443 6.24942 3.99989 6.35214 3.99989H10.5477C11.0449 3.99989 11.508 4.03425 11.9318 4.10542C12.0527 4.12567 12.1707 4.14959 12.2851 4.17598C12.3996 4.20236 12.5105 4.23181 12.6179 4.26494C12.6719 4.28151 12.7247 4.29869 12.777 4.31648C12.9848 4.38888 13.1785 4.47416 13.3569 4.57294C13.567 3.17222 13.3551 2.22001 12.6308 1.35676C11.8332 0.406381 10.3922 -0.000396729 8.54795 -0.000396729H3.19606C2.81923 -0.000396729 2.49875 0.286127 2.44006 0.675112L0.211376 15.4473C0.167354 15.7388 0.382768 16.0026 0.665095 16.0026H3.96909L4.79905 10.501L5.69064 4.59134Z", fill: "#1C3587" }) }))] })));
};

})();

var __webpack_exports__PaypalLogo = __webpack_exports__.D;
export { __webpack_exports__PaypalLogo as PaypalLogo };
